import { Directive, ElementRef, HostListener, Input, OnDestroy, OnInit, Renderer2, inject } from '@angular/core';
import { ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import intlTelInput from 'intl-tel-input';
import { NomidioPhoneValidators } from '../../validation/nomidio-phone-validators';

@Directive({
  selector: 'input[nomItiPhoneInput]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: ItiPhoneInputDirective,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useValue: NomidioPhoneValidators.phone,
    },
  ],
  standalone: false,
})
export class ItiPhoneInputDirective implements ControlValueAccessor, OnInit, OnDestroy {
  private readonly el = inject(ElementRef);
  private readonly renderer = inject(Renderer2);

  @Input() public preferredCountries: string[] = ['gb', 'us'];

  public onChange: Function = (_: any) => null;
  public onTouched: Function = () => null;

  private iti: intlTelInput.Plugin | null = null;

  public ngOnInit(): void {
    this.iti = intlTelInput(this.el.nativeElement, {
      customContainer: 'form-control-container',
      preferredCountries: this.preferredCountries,
      separateDialCode: true,
    });
  }

  public ngOnDestroy(): void {
    this.iti?.destroy();
  }

  public writeValue(value: any): void {
    if (typeof value === 'string' || value instanceof String) {
      this.iti?.setNumber(value as string);
      // reformat from string to PhoneValue
      // need setTimeout to ensure onChange has been registered
      setTimeout(() => {
        this.onChange(this.getValue());
      });
    } else if (value === null || value === undefined) {
      this.iti?.setNumber('');
    } else {
      throw Error('invalid value type');
    }
  }

  public registerOnChange(onChange: Function): void {
    this.onChange = onChange;
  }

  public registerOnTouched(onTouched: Function): void {
    this.onTouched = onTouched;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.renderer.setProperty(this.el.nativeElement, 'disabled', isDisabled);
  }

  @HostListener('input')
  public onInput(): void {
    this.onChange(this.getValue());
  }

  @HostListener('countrychange')
  public onCountryChange(): void {
    this.onChange(this.getValue());
  }

  @HostListener('blur')
  public onBlur(): void {
    this.onTouched();
  }

  private getValue(): string {
    if (!this.iti?.getNumber()) {
      return '';
    } else {
      return this.iti.getNumber();
    }
  }
}
